import store from '@/store';

export default (headers = {}) => {
  return {
    headers: {
      'X-USER-TOKEN': `${store.getters['user/token']}`,
      ...headers
    }
  };
};
